// /src/pages/CreateLabelledStock.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import LabelledStockForm from "../components/LabelledStockForm";
import { useDispatch } from "react-redux";

import { setCategoryList } from "../slices/categorySlice";
import { setProductList } from "../slices/productSlice";
import { setVendorList } from "../slices/vendorSlice";
import { setDesignList } from "../slices/designSlice";
import { setPurityList } from "../slices/puritySlice";
import { setBranchList } from "../slices/branchSlice";
import { setStoneList } from "../slices/stoneSlice";
import { setCounterList } from "../slices/counterSlice";

import { useGetAllVendorsQuery } from "../toolkitServices/vendorApi";
import { useGetAllBranchesQuery } from "../toolkitServices/branchApi";
import { useGetAllCategoriesQuery } from "../toolkitServices/categoryApi";
import { useGetAllProductsQuery } from "../toolkitServices/productApi";
import { useGetAllPuritiesQuery } from "../toolkitServices/purityApi";
import { useGetAllDesignsQuery } from "../toolkitServices/designApi";
import { useGetAllStonesQuery } from "../toolkitServices/stoneApi";
import { useGetCountersQuery } from "../toolkitServices/counterApi";

const CreateLabelledStock = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: vendors }    = useGetAllVendorsQuery({ page: 1, limit: 10, search: "" });
  const { data: branches }   = useGetAllBranchesQuery();
  const { data: categories } = useGetAllCategoriesQuery();
  const { data: products }   = useGetAllProductsQuery();
  const { data: designs }    = useGetAllDesignsQuery();
  const { data: purities }   = useGetAllPuritiesQuery();
  const { data: stones }     = useGetAllStonesQuery();
  const { data: counters }   = useGetCountersQuery();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
    control,
  } = useForm();

  useEffect(() => {
    if (categories?.data?.length) dispatch(setCategoryList(categories.data));
    if (products?.data?.length)   dispatch(setProductList(products.data));
    if (vendors?.data?.length)    dispatch(setVendorList(vendors.data));
    if (designs?.data?.length)    dispatch(setDesignList(designs.data));
    if (purities?.data?.length)   dispatch(setPurityList(purities.data));
    if (branches?.data?.length)   dispatch(setBranchList(branches.data));
    if (stones?.data?.length)     dispatch(setStoneList(stones.data));
    if (counters?.data?.length)   dispatch(setCounterList(counters.data));
  }, [categories, products, vendors, designs, purities, branches, stones, counters, dispatch]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "Backspace") {
        e.preventDefault();
        navigate(-1);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  const onSubmit = () => {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="max-w-8xl mx-auto bg-white shadow-lg rounded-xl px-2 py-2 relative"
    >
      <LabelledStockForm
        handleSubmit={handleSubmit}
        register={register}
        onSubmit={onSubmit}
        errors={errors}
        control={control}
        /* 👇 auto-focus first top field on mount */
        autoFocusTopField
      />
    </motion.div>
  );
};

export default CreateLabelledStock;
